import { toLower } from 'lodash';
import { ALL_COUNTRY_CODES } from 'static/data/Countries';
import { Localization } from 'static/localization/localization';

export enum EImageCategories {
    ALL,
    CATEGORIES,
    YOURS,
    NATURE,
    VEHICLES,
    BUILDINGS,
    ANIMALS,
    FOOD,
    FLAGS
}

const IMAGE_GALLERY_DATA: {
    name: string;
    keywords: string[];
    category: EImageCategories[];
}[] = [
    {
        name: 'tree1',
        keywords: ['tree'],
        category: [EImageCategories.NATURE]
    },
    {
        name: 'tree2',
        keywords: ['tree'],
        category: [EImageCategories.NATURE]
    },
    {
        name: 'tree3',
        keywords: ['tree'],
        category: [EImageCategories.NATURE]
    },
    {
        name: 'tree4',
        keywords: ['tree'],
        category: [EImageCategories.NATURE]
    },
    {
        name: 'tree5',
        keywords: ['tree'],
        category: [EImageCategories.NATURE]
    },
    {
        name: 'tree6',
        keywords: ['tree'],
        category: [EImageCategories.NATURE]
    },
    {
        name: 'tree7',
        keywords: ['tree'],
        category: [EImageCategories.NATURE]
    },
    {
        name: 'tree8',
        keywords: ['tree'],
        category: [EImageCategories.NATURE]
    },
    {
        name: 'tree9',
        keywords: ['tree'],
        category: [EImageCategories.NATURE]
    },
    {
        name: 'tree10',
        keywords: ['tree'],
        category: [EImageCategories.NATURE]
    },
    {
        name: 'bush1',
        keywords: ['bush'],
        category: [EImageCategories.NATURE]
    },
    {
        name: 'bush2',
        keywords: ['bush'],
        category: [EImageCategories.NATURE]
    },
    {
        name: 'bush3',
        keywords: ['bush'],
        category: [EImageCategories.NATURE]
    },
    {
        name: 'bush4',
        keywords: ['bush'],
        category: [EImageCategories.NATURE]
    },
    {
        name: 'bush5',
        keywords: ['bush'],
        category: [EImageCategories.NATURE]
    },
    {
        name: 'cloud1',
        keywords: ['cloud'],
        category: [EImageCategories.NATURE]
    },
    {
        name: 'cloud2',
        keywords: ['cloud'],
        category: [EImageCategories.NATURE]
    },
    {
        name: 'cloud3',
        keywords: ['cloud'],
        category: [EImageCategories.NATURE]
    },
    {
        name: 'cloud4',
        keywords: ['cloud'],
        category: [EImageCategories.NATURE]
    },
    {
        name: 'cloud5',
        keywords: ['cloud'],
        category: [EImageCategories.NATURE]
    },
    {
        name: 'plane1',
        keywords: ['plane'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'plane2',
        keywords: ['plane'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'plane3',
        keywords: ['plane'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'plane4',
        keywords: ['plane'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'plane5',
        keywords: ['plane'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'heli1',
        keywords: ['heli'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'heli2',
        keywords: ['heli'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'heli3',
        keywords: ['heli'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'heli4',
        keywords: ['heli'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'heli5',
        keywords: ['heli'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'car1',
        keywords: ['car'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'car2',
        keywords: ['car'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'car3',
        keywords: ['car'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'car4',
        keywords: ['car'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'car5',
        keywords: ['car'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'car6',
        keywords: ['car'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'car7',
        keywords: ['car'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'car8',
        keywords: ['car'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'car9',
        keywords: ['car'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'boat1',
        keywords: ['boat', 'ship'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'boat2',
        keywords: ['boat', 'ship'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'boat3',
        keywords: ['boat', 'ship'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'boat4',
        keywords: ['boat', 'ship'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'boat5',
        keywords: ['boat', 'ship'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'boat6',
        keywords: ['boat', 'ship'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'boat7',
        keywords: ['boat', 'ship'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'boat8',
        keywords: ['boat', 'ship'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'boat9',
        keywords: ['boat', 'ship'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'boat10',
        keywords: ['boat', 'ship'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'bus1',
        keywords: ['bus'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'bus2',
        keywords: ['bus'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'bus3',
        keywords: ['bus'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'bus4',
        keywords: ['bus'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'bus5',
        keywords: ['bus'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'bus6',
        keywords: ['bus'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'train1',
        keywords: ['train'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'train2',
        keywords: ['train'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'train3',
        keywords: ['train'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'stand1',
        keywords: ['stand', 'drink', 'food'],
        category: [EImageCategories.FOOD]
    },
    {
        name: 'stand2',
        keywords: ['stand', 'drink', 'food'],
        category: [EImageCategories.FOOD]
    },
    {
        name: 'stand3',
        keywords: ['stand', 'drink', 'food'],
        category: [EImageCategories.FOOD]
    },
    {
        name: 'stand4',
        keywords: ['stand', 'drink', 'food'],
        category: [EImageCategories.FOOD]
    },
    {
        name: 'stand5',
        keywords: ['stand', 'drink', 'food'],
        category: [EImageCategories.FOOD]
    },
    {
        name: 'stand6',
        keywords: ['stand', 'drink', 'food'],
        category: [EImageCategories.FOOD]
    },
    {
        name: 'truck1',
        keywords: ['truck', 'drink', 'food'],
        category: [EImageCategories.VEHICLES, EImageCategories.FOOD]
    },
    {
        name: 'truck2',
        keywords: ['truck', 'drink', 'food'],
        category: [EImageCategories.VEHICLES, EImageCategories.FOOD]
    },
    {
        name: 'truck3',
        keywords: ['truck', 'drink', 'food'],
        category: [EImageCategories.VEHICLES, EImageCategories.FOOD]
    },
    {
        name: 'truck4',
        keywords: ['truck', 'drink', 'food'],
        category: [EImageCategories.VEHICLES, EImageCategories.FOOD]
    },
    {
        name: 'truck5',
        keywords: ['truck', 'drink', 'food'],
        category: [EImageCategories.VEHICLES, EImageCategories.FOOD]
    },
    {
        name: 'truck6',
        keywords: ['truck', 'drink', 'food'],
        category: [EImageCategories.VEHICLES, EImageCategories.FOOD]
    },
    {
        name: 'motor1',
        keywords: ['motor', 'bike'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'motor2',
        keywords: ['motor', 'bike'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'motor3',
        keywords: ['motor', 'bike'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'motor4',
        keywords: ['motor', 'bike'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'motor5',
        keywords: ['motor', 'bike'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'bike1',
        keywords: ['bike', 'bicycle'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'bike2',
        keywords: ['bike', 'bicycle'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'bike3',
        keywords: ['bike', 'bicycle'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'bike4',
        keywords: ['bike', 'bicycle'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'caravan1',
        keywords: ['caravan'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'caravan2',
        keywords: ['caravan'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'caravan3',
        keywords: ['caravan'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'caravan4',
        keywords: ['caravan'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'caravan5',
        keywords: ['caravan'],
        category: [EImageCategories.VEHICLES]
    },
    {
        name: 'tent1',
        keywords: ['tent'],
        category: [EImageCategories.BUILDINGS]
    },
    {
        name: 'tent2',
        keywords: ['tent'],
        category: [EImageCategories.BUILDINGS]
    },
    {
        name: 'tent3',
        keywords: ['tent'],
        category: [EImageCategories.BUILDINGS]
    },
    {
        name: 'tent4',
        keywords: ['tent'],
        category: [EImageCategories.BUILDINGS]
    },
    {
        name: 'tent5',
        keywords: ['tent'],
        category: [EImageCategories.BUILDINGS]
    },
    {
        name: 'tent6',
        keywords: ['tent'],
        category: [EImageCategories.BUILDINGS]
    },
    {
        name: 'stage1',
        keywords: ['stage'],
        category: [EImageCategories.BUILDINGS]
    },
    {
        name: 'stage2',
        keywords: ['stage'],
        category: [EImageCategories.BUILDINGS]
    },
    {
        name: 'stage3',
        keywords: ['stage'],
        category: [EImageCategories.BUILDINGS]
    },
    {
        name: 'stage4',
        keywords: ['stage'],
        category: [EImageCategories.BUILDINGS]
    },
    {
        name: 'baldeagle',
        keywords: ['eagle', 'bird'],
        category: [EImageCategories.ANIMALS]
    },
    {
        name: 'brownbear',
        keywords: ['bear'],
        category: [EImageCategories.ANIMALS]
    },
    {
        name: 'cat',
        keywords: ['cat'],
        category: [EImageCategories.ANIMALS]
    },
    {
        name: 'cheetah',
        keywords: ['cheetah'],
        category: [EImageCategories.ANIMALS]
    },
    {
        name: 'chimpanzee',
        keywords: ['chimpanzee'],
        category: [EImageCategories.ANIMALS]
    },
    {
        name: 'dog',
        keywords: ['dog'],
        category: [EImageCategories.ANIMALS]
    },
    {
        name: 'elephant',
        keywords: ['elephant'],
        category: [EImageCategories.ANIMALS]
    },
    {
        name: 'flamingo',
        keywords: ['flamingo'],
        category: [EImageCategories.ANIMALS]
    },
    {
        name: 'gazelle',
        keywords: ['gazelle'],
        category: [EImageCategories.ANIMALS]
    },
    {
        name: 'giraffe',
        keywords: ['giraffe'],
        category: [EImageCategories.ANIMALS]
    },
    {
        name: 'gorilla',
        keywords: ['gorilla'],
        category: [EImageCategories.ANIMALS]
    },
    {
        name: 'hamster',
        keywords: ['hamster'],
        category: [EImageCategories.ANIMALS]
    },
    {
        name: 'hippopotamus',
        keywords: ['hippopotamus'],
        category: [EImageCategories.ANIMALS]
    },
    {
        name: 'horse',
        keywords: ['horse'],
        category: [EImageCategories.ANIMALS]
    },
    {
        name: 'kangaroo',
        keywords: ['kangaroo'],
        category: [EImageCategories.ANIMALS]
    },
    {
        name: 'koala',
        keywords: ['koala'],
        category: [EImageCategories.ANIMALS]
    },
    {
        name: 'lemur',
        keywords: ['lemur'],
        category: [EImageCategories.ANIMALS]
    },
    {
        name: 'lion',
        keywords: ['lion'],
        category: [EImageCategories.ANIMALS]
    },
    {
        name: 'llama',
        keywords: ['llama'],
        category: [EImageCategories.ANIMALS]
    },
    {
        name: 'meerkat',
        keywords: ['meerkat'],
        category: [EImageCategories.ANIMALS]
    },
    {
        name: 'moose',
        keywords: ['moose'],
        category: [EImageCategories.ANIMALS]
    },
    {
        name: 'mouse',
        keywords: ['mouse'],
        category: [EImageCategories.ANIMALS]
    },
    {
        name: 'ostrich',
        keywords: ['ostrich'],
        category: [EImageCategories.ANIMALS]
    },
    {
        name: 'panda',
        keywords: ['panda'],
        category: [EImageCategories.ANIMALS]
    },
    ...ALL_COUNTRY_CODES.map((country) => ({
        name: `flag-${country.code2.toLowerCase()}`,
        keywords: [...country.name.split(' ').map(toLower), country.code3],
        category: [EImageCategories.FLAGS]
    }))
];

export interface IImageGalleryData {
    key?: string;
    imageUrl: string;
    keywords: string[];
    category: EImageCategories[];
}

export function getGalleryImages(): IImageGalleryData[] {
    return IMAGE_GALLERY_DATA.map((source) => {
        return {
            key: source.name,
            imageUrl: `https://dvtqxks0zalev.cloudfront.net/image-gallery/${source.name}.png`,
            keywords: source.keywords,
            category: source.category
        };
    });
}

export const useGetImageCategories = () => {
    const CATEGORIES: {
        key: EImageCategories;
        label: string;
    }[] = [
        {
            key: EImageCategories.ALL,
            label: Localization.GALLERY_ALL
        },
        {
            key: EImageCategories.YOURS,
            label: Localization.GALLERY_YOUR_IMAGES
        },
        {
            key: EImageCategories.CATEGORIES,
            label: Localization.GALLERY_CATEGORY_IMAGES
        },
        {
            key: EImageCategories.NATURE,
            label: Localization.GALLERY_NATURE
        },
        {
            key: EImageCategories.ANIMALS,
            label: Localization.GALLERY_ANIMALS
        },
        {
            key: EImageCategories.VEHICLES,
            label: Localization.GALLERY_VEHICLES
        },
        {
            key: EImageCategories.BUILDINGS,
            label: Localization.GALLERY_BUILDINGS
        },
        { key: EImageCategories.FLAGS, label: Localization.GALLERY_FLAGS }
    ];

    return {
        categories: CATEGORIES
    };
};
